const tokenKey = "token";
const itemsMenuKey = "itensMenu";
const nomeCompletoKey = "nomeCompleto"

export const Token = {
  setToken: (value: string) => localStorage.setItem(tokenKey, value),
  getToken: () => localStorage.getItem(tokenKey),
  removeToken: () => localStorage.removeItem(tokenKey),
};

export const ItemsMenu = {
  setItemsMenu: (value: string) => localStorage.setItem(itemsMenuKey, value),
  getItemsMenu: () => localStorage.getItem(itemsMenuKey),
  removeItemsMenu: () => localStorage.removeItem(itemsMenuKey),
};

export const NomeCompleto = {
  setNomeCompleto: (value: string) => localStorage.setItem(nomeCompletoKey, value),
  getNomeCompleto: () => localStorage.getItem(nomeCompletoKey),
  removeNomeCompleto: () => localStorage.removeItem(nomeCompletoKey),
};